/**
 * WorkerLayout — wraps AdminLayout with role="worker" and T_WORKER (orange) theme.
 * Provides a simplified sidebar with Today | Schedule links.
 */
import AdminLayout from './AdminLayout';

export default function WorkerLayout({ children }) {
  return (
    <AdminLayout role="worker">
      {children}
    </AdminLayout>
  );
}
